<app-page-transition-overlay></app-page-transition-overlay>
<app-global-alert></app-global-alert>
<app-cookie-consent></app-cookie-consent>

<ion-app>
  @if ((hideAppShell$ | async) !== true) {
    <ion-header translucent="true">
      <ion-toolbar class="app-header">
        <ion-buttons slot="start">
          <ion-menu-button color="light" [appTooltip]="'chrome.tt.menu' | translate" tooltipPosition="bottom"></ion-menu-button>
        </ion-buttons>
        <ion-title color="light">{{ (tenantName$ | async) ?? 'Gastro Management' }}</ion-title>
        <ion-buttons slot="end">
          @if (isAuthenticated$ | async) {
            <button class="notif-bell-btn" (click)="overlay.toggle('notifications')"
              [attr.aria-label]="'notifications.bell' | translate"
              [appTooltip]="'chrome.tt.notifications' | translate" tooltipPosition="bottom">
              <ion-icon name="notifications-outline"></ion-icon>
              @if ((unreadCount$ | async)! > 0) {
                <span class="notif-badge">{{ unreadCount$ | async }}</span>
              }
            </button>
            @if (user$ | async; as u) {
              <button class="avatar-header-btn" (click)="overlay.toggle('profile')"
                [attr.aria-label]="'profileMenu.aria' | translate"
                [appTooltip]="'chrome.tt.account' | translate" tooltipPosition="bottom">
                <span class="header-avatar">
                  @if (u.avatarId) {
                    <img [src]="avatarUrl(u.avatarId)" alt="" />
                  } @else {
                    {{ u.firstName?.charAt(0) }}{{ u.lastName?.charAt(0) }}
                  }
                </span>
              </button>
            }
          }
        </ion-buttons>
      </ion-toolbar>
      @if (showPublicNav$ | async) {
        <ion-toolbar class="public-nav">
          <div class="public-nav-links">
            <a routerLink="/home" routerLinkActive="active" [routerLinkActiveOptions]="{exact: true}">{{ 'home.subnav.home' | translate }}</a>
            <a routerLink="/products" routerLinkActive="active">{{ 'home.subnav.products' | translate }}</a>
            <a routerLink="/pricing" routerLinkActive="active">{{ 'home.subnav.pricing' | translate }}</a>
            <a routerLink="/status" routerLinkActive="active">{{ 'home.subnav.status' | translate }}</a>
            <a routerLink="/security" routerLinkActive="active">{{ 'home.subnav.security' | translate }}</a>
            <a routerLink="/developer" routerLinkActive="active">{{ 'home.subnav.developer' | translate }}</a>
            @if (wikiUrl) {
              <a [href]="wikiUrl" target="_blank" rel="noopener">{{ 'home.subnav.wiki' | translate }}</a>
            }
            <a routerLink="/contact" routerLinkActive="active">{{ 'home.subnav.contact' | translate }}</a>
          </div>
        </ion-toolbar>
      }
      <app-connection-banner></app-connection-banner>
      @if (navigating$ | async) {
        <ion-progress-bar type="indeterminate" class="route-progress"></ion-progress-bar>
      }
    </ion-header>
  }

  <!-- Dropdown panels are rendered OUTSIDE the header on purpose: the toolbar's
  backdrop-filter creates a containing block that would trap/clip their
  position:fixed. Here they are positioned relative to the viewport. -->
  <app-notifications-center></app-notifications-center>
  <app-user-menu [user$]="user$"></app-user-menu>

  @if ((hideAppShell$ | async) !== true) {
    <app-side-menu></app-side-menu>
  }

  <ion-router-outlet id="main-content"></ion-router-outlet>
</ion-app>
